module.exports = __webpack_public_path__ + "img/Boy_030013.f9b6b23e.png";